class ActiveDialog {
    /**
     * Канал «закрыть как пользователь»: VDialogV3 регистрирует сюда свой close()
     * при маунте. Сервис зовёт его на Escape — с эмитом close и confirmBeforeClose.
     * null — диалог не на VDialogV3, закрывается напрямую через hide().
     */
    public closeRequest: (() => void) | null = null;

    constructor(
        public id: string,
        public component: any,
        public props: Record<string, any> = {},
        public slots: Record<string, any> | string | null = null,
        public handlers: Record<string, (data?: any) => void> = {},
        public zIndex: number,
        public dialogName: string,
        /**
         * Имя сущности для синхронизации с URL (routeEntityName диалога).
         * null — диалог без роутинга. Хранится здесь, а не достаётся из
         * реестра по dialogName: сервису нужно убрать запись из URL в hide(),
         * а поиск по имени бросает на ненайденном диалоге.
         */
        public routeEntityName: string | null = null,
    ) {}
}

export default ActiveDialog;